import api from 'api'
import { CACHE_TAG_ACCOUNT_GROUP_LIST } from '../../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    createAccountGroup: build.mutation({
      query: body => ({ url: '/api/v1/core/accounts/groups', method: 'POST', body }),
      invalidatesTags: [CACHE_TAG_ACCOUNT_GROUP_LIST],
    }),
  }),
})

export const { useCreateAccountGroupMutation } = extendedApi
